import $axios from "@/service/httpServer";

export const addPlatformOrg = (p) => $axios.post('/Web/Backend/Orgnization/add', p);
export const updatePlatformOrg = (p) => $axios.post('/Web/Backend/Orgnization/update', p);
export const listPlatformOrg = (p) => $axios.post('/Web/Backend/Orgnization/list', p);
export const deletePlatformOrg = (p) => $axios.post('/Web/Backend/Orgnization/delete', p);
